import React, { Component } from "react";
import track from "../lib/tracking";
import LocationInput from "./LocationInput";
import CountryInput from "./CountryInput";
import SelectTabs from "./SelectTabs";

import _ from "lodash";

import Button from "../elements/Button";

class CinemaSearch extends Component {
  state = {
    location: "",
    locationResults: [],
    locationSelected: null,
    locationFilter: "location",
    countryCodes: [],
    country: "",
    countryResults: [],
    distance: 20
  };
  update = () => {
    if (!this.state.locationSelected && this.state.countryCodes.length < 1) {
      this.props.setStatus("error", "empty location");
      return;
    }
    const locationFilter = this.getLocationFilterString();
    this.props.setStatus("loading", "");
    const headers = new Headers();
    headers.append("x-api-key", "c87bfbb769147aa04b3390a81dd07e5d");
    track("submit_search", {
      option_search_main: "cinemas",
      option_location_filter: this.state.locationFilter,
      location_name: this.state.locationFilter === "location" ? this.state.locationSelected.formatted_address : this.state.countryCodes.map(o => o.name),
      distance: this.state.distance
    });
    fetch(
      "https://api.internationalshowtimes.com/v4/cinemas?lang=en&" +
      locationFilter,
      {
        headers: headers
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.cinemas.length === 0) {
          this.props.setStatus("error", "empty results");
          return;
        }
        this.props.setResults({
          cinemas: responseJson.cinemas,
          location: this.state.locationFiler === "location"
            ? this.state.locationSelected.formatted_address
            : this.state.countryCodes.map(o => o.name).join(", ")
        });
        this.props.setStatus("", "");
      });
  };

  getLocationFilterString = () => {
    switch (this.state.locationFilter) {
      case "location":
        const coordinates =
          this.state.locationSelected.geometry.location.lat +
          "," +
          this.state.locationSelected.geometry.location.lng;
        return "&location=" + coordinates + "&distance=" + this.state.distance;
      case "country":
        return (
          "&countries=" + this.state.countryCodes.map(o => o.code).join(",")
        );
      default:
        return null;
    }
  };

  getLocation = _.debounce(() => {
    fetch(
      "https://maps.googleapis.com/maps/api/geocode/json?address=" +
      this.state.location +
      "&key=AIzaSyBxneIqyI3u-9mLOTTor7xrIDNUxP_6A5Y"
    )
      .then(response => response.json())
      .then(responseJson => {
        this.setState({ locationResults: responseJson.results || [] });
      });
  }, 500);

  handleLocationChange = value => {
    this.setState({ location: value });
    this.getLocation();
  };

  selectLocation = (location, selected) => {
    if ((!selected && this.state.locationSelected) || !location) {
      return;
    }
    this.setState({
      locationSelected: location,
      location: location.formatted_address,
      locationResults: []
    });
    this.props.setResults({});
    track("location_search", { location_name: location.formatted_address })
  };

  getCountry = _.debounce(() => {
    fetch("http://api.countrylayer.com/v2/name/" + this.state.country + "?access_key=aaa9b3348e4b8dcb0a727f0b13cf0bc5")
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.status && responseJson.status !== "200") {
          this.setState({ countryResults: [] });
          return;
        }
        this.setState({ countryResults: responseJson || [] });
      });
  }, 500);
  handleCountryChange = value => {
    this.setState({ country: value });
    this.getCountry();
  };

  addCountry = country => {
    this.setState(({ countryCodes }) => ({
      countryCodes: [...countryCodes, country],
      country: "",
      countryResults: []
    }));
    this.props.setResults({});
    track("location_search", { location_name: country.name })
  };

  handleDistanceChange = value => {
    this.setState({ distance: value });
    this.props.setResults({});
    track("distance_radius", { distance: value })
  };
  handleChange = (param, value) => {
    this.setState({ [param]: value });
  };

  getLocationFilterOptions = () => {
    switch (this.state.locationFilter) {
      case "location":
        return (
          <LocationInput
            tabIndex={1}
            focus={this.state.focus === 1}
            value={this.state.location}
            onChange={this.handleLocationChange}
            selectLocation={this.selectLocation}
            locations={this.state.locationResults}
            distance={this.state.distance}
            handleDistanceChange={this.handleDistanceChange}
          />
        );
      case "country":
        return (
          <CountryInput
            tabIndex={2}
            value={this.state.country}
            onChange={this.handleCountryChange}
            addCountry={this.addCountry}
            countries={this.state.countryResults}
            countryCodes={this.state.countryCodes}
            onDelete={(index) => this.setState(({ countryCodes }) => { countryCodes.splice(index, 1); return { countryCodes } })}
          />
        );
    }
  };

  changeLocationFilter = filter => {
    this.setState({
      locationFilter: filter,
      locationSelected: "",
      location: "",
      locationResults: [],
      cinemas: [],
      countryCodes: [],
      country: "",
      countryResults: []
    });
    this.props.setResults({});
  };

  render() {
    return (
      <div className="cinemas-search">
        <div className="menu--section">
          <div className="menu--header">Location filter type</div>
          <SelectTabs
            classes={["flex-row"]}
            selected={this.state.locationFilter}
            options={["location", "country"]}
            onValueChange={this.changeLocationFilter}
          />

          {this.getLocationFilterOptions()}

          <div className="menu--tab flex-row justify-center menu--go">
            <Button blue tabIndex={2} onClicked={this.update}>go &gt;</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default CinemaSearch;



// WEBPACK FOOTER //
// ./src/components/CinemaSearch.js